import "./App.css";
import ChatBar from "./components/ChatBar";
// import Template1 from "./components/template1";
// import Template2 from "./components/template2";
import Template3 from "./components/template3";
import Template4 from "./components/template4";
// import Template5 from "./components/template5";
import Template6 from "./components/template6";
import Template7 from "./components/template7";
import Template8 from "./components/template8";
import Template9 from "./components/template9";
import { useState } from "react";
// import section1 from "./assets/01-banner.png";
// import section2 from "./assets/02.png";
// import section3 from "./assets/03.png";
// import section4 from "./assets/04.png";
// import section5 from "./assets/05.png";
// import Footer from "./assets/footer.png";

// import Logo from "./assets/logo.png";
// import Button1 from "./assets/btn-b.png";
// import Button2 from "./assets/btn-c.png";

function App() {
  const [currentView, setCurrentView] = useState("default");
  const [aiAnswer, setAiAnswer] = useState("");
  const [template2Data, setTemplate2Data] = useState(null);

  const backtoHome = () => {
    setCurrentView("default");
  };

  const handleShowTemplate1 = () => {
    setCurrentView("template1");
  };

  const handleShowTemplate2 = data => {
    setTemplate2Data(data);
    setCurrentView("template2");
  };

  const handleShowTemplate3 = answer => {
    setAiAnswer(answer);
    setCurrentView("template3");
  };
  const handleShowTemplate4 = answer => {
    setCurrentView("template4");
  };
  const handleShowTemplate5 = answer => {
    setCurrentView("template5");
  };
  const handleShowTemplate6 = () => {
    setCurrentView("template6");
  };
  const handleShowTemplate7 = () => {
    setCurrentView("template7");
  };
  const handleShowTemplate8 = () => {
    setCurrentView("template8");
  };

  const handleShowTemplate9 = () => {
    setCurrentView("template9");
  };

  const renderContent = () => {
    switch (currentView) {
      // case "template1":
      //   return (
      //     <div className="App">
      //       <header>
      //         <div className="mx-box">
      //           <div className="menu-box" onClick={backtoHome}>
      //             <span>Products</span> <span>Solutions</span> <span>Pricing</span>
      //             <span>Company</span>
      //           </div>{" "}
      //           <div className="logo-box" onClick={backtoHome}>
      //             <img src={Logo} alt="" />
      //           </div>{" "}
      //           <div className="btn-box">
      //             <button>
      //               <img src={Button1} alt="" />
      //             </button>{" "}
      //             <button>
      //               <img src={Button2} alt="" />
      //             </button>
      //           </div>
      //         </div>{" "}
      //         <div className="line"></div>
      //       </header>
      //       <Template1 />
      //     </div>
      //   );
      // case "template2":
      //   return template2Data ? (
      //     <div className="App">
      //       <header>
      //         <div className="mx-box">
      //           <div className="menu-box" onClick={backtoHome}>
      //             <span>Products</span> <span>Solutions</span> <span>Pricing</span>
      //             <span>Company</span>
      //           </div>{" "}
      //           <div className="logo-box" onClick={backtoHome}>
      //             <img src={Logo} alt="" />
      //           </div>{" "}
      //           <div className="btn-box">
      //             <button>
      //               <img src={Button1} alt="" />
      //             </button>{" "}
      //             <button>
      //               <img src={Button2} alt="" />
      //             </button>
      //           </div>
      //         </div>{" "}
      //         <div className="line"></div>
      //       </header>
      //       <Template2 data={template2Data} />
      //     </div>
      //   ) : null;
      case "template3":
        return <Template3 answer={aiAnswer} />;
      case "template4":
        return (
          <div className="App">
            <Template4 />
          </div>
        );
      // case "template5":
      //   return (
      //     <div className="App">
      //       <header>
      //         <div className="mx-box">
      //           <div className="menu-box" onClick={backtoHome}>
      //             <span>Products</span> <span>Solutions</span> <span>Pricing</span>
      //             <span>Company</span>
      //           </div>{" "}
      //           <div className="logo-box" onClick={backtoHome}>
      //             <img src={Logo} alt="" />
      //           </div>{" "}
      //           <div className="btn-box">
      //             <button>
      //               <img src={Button1} alt="" />
      //             </button>{" "}
      //             <button>
      //               <img src={Button2} alt="" />
      //             </button>
      //           </div>
      //         </div>{" "}
      //         <div className="line"></div>
      //       </header>
      //       <Template5 />
      //     </div>
      //   );
      case "template6":
        return (
          <div className="App">
            <Template6 />
          </div>
        );
      case "template7":
        return (
          <div className="App">
            <Template7 />
          </div>
        );
      case "template8":
        return (
          <div className="App">
            <Template8 />
          </div>
        );
      case "template9":
        return (
          <div className="App">
            <Template9 />
          </div>
        );
      default:
        return (
          <iframe src="https://aristai.io" title="AristAI" style={{ width: "100%", height: "99vh", border: "none", margin: "0px", padding: "0px" }} />
        );
    }
  };

  return (
    <div>
      {renderContent()}
      <ChatBar
        onSendMessage={handleShowTemplate1}
        onShowTemplate2={handleShowTemplate2}
        onShowTemplate3={handleShowTemplate3}
        onShowTemplate4={handleShowTemplate4}
        onShowTemplate5={handleShowTemplate5}
        onShowTemplate6={handleShowTemplate6}
        onShowTemplate7={handleShowTemplate7}
        onShowTemplate8={handleShowTemplate8}
        onShowTemplate9={handleShowTemplate9}
      />
    </div>
  );
}

export default App;
